import appReducer from "./app";
import { configureStore } from "@reduxjs/toolkit";
import departmentReducer from "./department";
import { enableMapSet } from "immer";
import orderStateReducer from "./orderState";
import partnerPortalReducer from "./partnerPortal";
// Added to utilize Map data structure in typescript
enableMapSet();

export const store = configureStore({
  reducer: {
    app: appReducer,
    department: departmentReducer,
    orderState: orderStateReducer,
    partnerPortal: partnerPortalReducer,
  },
  devTools: {
    // This is needed for special data structures like Map to show up in the Redux devTools
    serialize: {
      options: true,
    },
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
